var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("accounts.basic_info"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.display_name"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.primary_contact_name"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.contact_name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.contact_name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.company_name"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.company_name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.email"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.email != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.email))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.website"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.website != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.website))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.primary_currency"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.currency != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewAccount.currency.code) +
                    "-" +
                    _vm._s(_vm.viewAccount.currency.name)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.role"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.role != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.role.toUpperCase()))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.status"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.status != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.status.toUpperCase()))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.account_type"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount && _vm.viewAccount.account_type != null
            ? _c("p", [
                _vm._v(_vm._s(_vm.viewAccount.account_type.toUpperCase())),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.viewAccount &&
      _vm.viewAccount.account_type != null &&
      _vm.viewAccount.account_type === "funder" &&
      _vm.auditInfo
        ? _c("div", [
            _c("div", { staticClass: "page-header" }, [
              _c("h3", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("general.auditor_info"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.display_name"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .name != null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.name
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.primary_contact_name"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .account.contact_name != null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.account.contact_name
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.company_name"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .company != null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.company.name
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.phone"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .company &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .company.phone != null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.company.phone
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.email"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .email != null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.email
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.website"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_link_audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .account &&
                _vm.viewAccount.user.funder_link_audit_account.audit_account
                  .account.website
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_link_audit_account
                              .audit_account.account.website
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.viewAccount &&
      _vm.viewAccount.account_type != null &&
      _vm.viewAccount.account_type === "funder" &&
      _vm.formInfo
        ? _c("div", [
            _c("div", { staticClass: "page-header" }, [
              _c("h3", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("general.form_info"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 mb-4" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("accounts.display_name"))),
                ]),
                _vm._v(" "),
                _vm.viewAccount &&
                _vm.viewAccount.user &&
                _vm.viewAccount.user.funder_islamic_form &&
                _vm.viewAccount.user.funder_islamic_form.islamic_form &&
                _vm.viewAccount.user.funder_islamic_form.islamic_form.name !=
                  null
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.viewAccount.user.funder_islamic_form
                              .islamic_form.name
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }